import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/vestanian.png";
import projImg2 from "../assets/img/mrp.png";
import projImg3 from "../assets/img/pmb.png";
import projImg4 from "../assets/img/so.png";
import projImg5 from "../assets/img/sg.png";
import projImg6 from "../assets/img/siakad.png";
import projImg7 from "../assets/img/fr.png";
import projImg8 from "../assets/img/wms.png";
import projImg9 from "../assets/img/hr.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {

      description: "Aplikasi Investasi Pertanian",
      imgUrl: projImg1,
    },
    {
      description: "MRP System",
      imgUrl: projImg2,
    },
    {
      description: "Sistem Penerimaan Mahasiswa",
      imgUrl: projImg3,
    },
    {
      description: "Smart Office (IoT Project)",
      imgUrl: projImg4,
    },
    {
      description: "Smart Gate Sistem (IoT Project)",
      imgUrl: projImg5,
    },
    {
      description: "Akademik Sistem",
      imgUrl: projImg6,
    },
    {
      description: "Face Recognition (IoT Project)",
      imgUrl: projImg7,
    },
    {
      description: "Warehouse Management System",
      imgUrl: projImg8,
    },
    {
      description: "HRMIS System",
      imgUrl: projImg9,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p>I show you to all the big and small websites I have done so far</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    {/* <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Tab 1</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Tab 2</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Tab 3</Nav.Link>
                      </Nav.Item>
                    </Nav> */}
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {
                            projects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="section">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
